import MicroModal from 'micromodal';
import {disablePageScroll, enablePageScroll} from 'scroll-lock';
import UiElement from '../../../shared/ui-element/ui-element';
import SignupFormManager from '../signup-form/signup-form-manager';
import analytics from '../../../shared/analytics';
import isIpadOS from '../../utils/is-ipados';

import './signup-modal.scss';

export default class SignupModal extends UiElement {
  ui = {
    modal: '#signup-modal',
    modalCloseBtn: '#signup-modal .modal__close',
    modalOverlay: '#signup-modal .modal__overlay',

    modalMacLessContainer: '#signup-modal .signup-modal__mac-less',
    modalMacLessSignupBtn: '#signup-modal .js-signup-modal-mac-less-signup-btn',

    modalSignupFormContainer: '#signup-modal .signup-modal__form',
  };

  events = {
    'click @ui.modalMacLessSignupBtn': 'handleSignupBtnClick',
  };

  constructor() {
    super();

    this.signupFormManager = new SignupFormManager();
  }

  init(options) {
    super.init(options);

    if (isIpadOS()) {
      this.showMacLessAlert();
    }
  }

  showMacLessAlert() {
    this.ui.modalMacLessContainer.classList.remove('signup-modal__mac-less_hidden');
    this.ui.modalSignupFormContainer.classList.add('signup-modal__form_hidden');
  }

  showSignupForm() {
    this.ui.modalMacLessContainer.classList.add('signup-modal__mac-less_hidden');
    this.ui.modalSignupFormContainer.classList.remove('signup-modal__form_hidden');
  }

  handleSignupBtnClick(e) {
    e.preventDefault();

    this.showSignupForm();
  }

  open(options = {}) {
    const {hideCloseBtn} = options;

    if (hideCloseBtn) {
      this.hideCloseBtn();
    }

    MicroModal.show('signup-modal', {
      onClose: this.onClose,
      closeTrigger: 'data-base-modal-close',
    });

    this.onOpen(options);
  }

  onOpen = ({tierType, signupHideSocials, campaign} = {}) => {
    analytics.trackPageView('Embedded Signup Flow', '/embedded-signup');
    analytics.trackTestGroup('popupFeature');

    this.signupFormManager.init({
      signupParams: {tier_type: tierType},
      signupHideSocials,
      campaign,
    });
    disablePageScroll(this.ui.modalOverlay);
  };

  onClose = () => {
    enablePageScroll(this.ui.modalOverlay);
    this.signupFormManager.destroy();
  };

  hideCloseBtn() {
    this.ui.modalCloseBtn.classList.add('modal__close_hidden');
  }
}
